import "./EmployeeList.scss";

import React from "react";
import { Link } from "react-router-dom";
import request from "request"
import usesFeatures from 'usesFeatures'
import { ApplicationContext } from "ApplicationContext"

import Table from 'Table'
import Header from 'Header'

class EmployeeList extends React.Component {
  static contextType = ApplicationContext

  componentDidMount() {
    this.props.fetchData("venue_admin/employees")
  }

  emptyTable = () => {
    return(
      <h3 className="is-size-6 is-italic">
        No Employees Found. Time to <Link to="/employees/new">create one</Link>?
      </h3>
    )
  }

  handleDelete = (employeeId) => {
    if (!confirm("Are you sure you want to delete this employee?")) return

    let req = request.delete(`venue_admin/employees/${employeeId}`)
    req.then(() => this.props.fetchData("venue_admin/employees"))
  }

  render() {
    if (!this.props.dataFetched) return false

    const { employees } = this.props
    const { user } = this.context.CurrentUserContext
    return(
      <div className="EmployeeList">
        <Header text={`Employees at ${ this.props.venue.name }`} />
        <div className="block">
          <div className="level mb-4">
            <div className="level-left"></div>
            <div className="level-right">
              <div className="level-item">
                <Link to="/time_logs" className="button is-info">
                  <span className="icon">
                    <i className="fas fa-clock"></i>
                  </span>
                  <span>Time Logs</span>
                </Link>
              </div>
              <div className="level-item">
                <Link to="/employees/new" className="button is-primary">
                  <span className="icon">
                    <i className="fas fa-plus"></i>
                  </span>
                  <span>New Employee</span>
                </Link>
              </div>
            </div>
          </div>
          <Table
            empty={this.emptyTable()}
            showHeader={true}
            headers={EMPLOYEE_HEADERS}
            formatters={EMPLOYEE_FORMATTERS(this.handleDelete)}
            tdClasses={EMPLOYEE_CLASSES}
            rows={employees}
          />
        </div>
      </div>
    )
  }
}

const EMPLOYEE_FORMATTERS = (handleDelete) => ({
  name: (e) => <Link to={`/employees/${e.id}/edit`}>{e.name}</Link>,
  authCode: (e) => <span className="tag is-info is-medium">{e.authCode}</span>,
  store: (e) => e.store ? e.store.name : <span className="has-text-grey-light">All Stores</span>,
  allTerminals: (e) => e.allTerminals
    ? <span className="tag is-success">Yes</span>
    : <span className="has-text-grey-light">No</span>,
  edit: (e) => <Link to={`/employees/${e.id}/edit`}>Edit</Link>,
  delete: (e) => <button className="button is-small is-danger" onClick={() => handleDelete(e.id)}>Delete</button>,
})

const EMPLOYEE_HEADERS = {
  name: "Name",
  authCode: "Auth Code",
  store: "Store",
  allTerminals: "All Terminals",
  edit: "",
  delete: "",
}

const EMPLOYEE_CLASSES = {
  authCode: "is-narrow",
  allTerminals: "is-narrow",
  edit: "is-narrow",
  delete: "is-narrow",
}

export default usesFeatures(['data'], EmployeeList)
